import { gql } from "@apollo/client";

export const CREATE_PROPERTY = gql`
  mutation createProperty(
    $deleted: Int
    $source: String
    $transaction_type: String
    $status: String
    $visible: String
    $featured: String
    $strive_slider: String
    $name: String
    $address: String
    $city: String
    $state: String
    $zip: String
    $latitude: Float
    $longitude: Float
    $highlights: text
    $media_kit: String
    $type: String
    $sqft: Int
    $list_price: Int
    $net_operating_income: Int
    $vacancy: Float
    $capitalization_rate: Float
    $sold_price: Int
    $down_payment: Int
    $close_of_escrow: String
    $listed_date: String
    $seller_fee_percentage: Float
    $total_fee: Float
    $lease_type: String
    $lease_commencement_date: String
    $lease_expiration_date: String
    $seller_id: String
    $buyer_id: String
    $year_built: String
    $video_url: text
    $close_noi: Int
    $proforma_noi: Int
    $proforma_base_rent: Int
    $proforma_cap_rate: Float
    $close_cap_rate: Float
    $close_price_per_sqft: Float
    $price_per_sqft: Float
    $listing_agent_1: String
    $listing_agent_2: String
    $listing_agent_3: String
    $listing_agent_4: String
    $referring_listing_agent:String
    $listing_agent_4_firm: String
    $referring_listing_agent_firm: String
    $buyer_agent_1: String
    $buyer_agent_2: String
    $buyer_agent_3: String
    $buyer_agent_4: String
    $referring_buyer_agent: String
    $referring_buyer_agent_firm: String
    $buyer_agent_4_firm: String
    $listing_agent_1_percent: Float
    $listing_agent_2_percent: Float
    $listing_agent_3_percent: Float
    $listing_agent_4_percent: Float
    $referring_listing_agent_percent: Float
    $buyer_agent_1_percent: Float
    $buyer_agent_2_percent: Float
    $buyer_agent_3_percent: Float
    $buyer_agent_4_percent: Float
    $referring_buyer_agent_percent: Float
    $single_tenant_subcategory: String
    $multi_tenant_subcategory: String
    $tenant_id: String
    $market: String
    $rent_per_sqft: Float
    $negotiation_price: Int
    $potential_fee: Float
    $list_fee: Float
    $buyside_fee: Float
    $negotiation_cap_rate: Float
    $category: String
    $hide_financials: String
    $is_proforma_pricing: String
    $date_removed: String
    $negotiation_price_per_sqft: Float
    $base_rent: Int
    $expiration_no_of_months: Int
    $expiration_date: String
    $effective_date: String
    $referral_fee: Float
    $hsc_team_member_1: String
    $hsc_team_member_1_percent: Float
    $hsc_team_member_1_net_fee: Float
    $hsc_team_member_1_net_percent: Float
    $hsc_team_member_1_gross_fee: Float
    $hsc_team_member_2: String
    $hsc_team_member_2_percent: Float
    $hsc_team_member_2_net_fee: Float
    $hsc_team_member_2_net_percent: Float
    $hsc_team_member_2_gross_fee: Float
    $hsc_agreement_file: String
    $loan_commitment_file: String
    $closing_statement_file: String
    $loan_closing_date: String
    $hsc_approved: String
    $hsc_approved_timestamp: String
    $hsc_approved_initials: String
    $hsc_status: String
    $hsc_price: Int
    $hsc_listed_date: String
    $hsc_expiration_no_of_months: Int
    $hsc_expiration_date: String
    $hsc_fee_percentage: Float
    $hsc_total_fee: Float
    $hsc_list_fee: Float
    $lender_id: String
    $loan_type: String
    $ltv: Float
    $loan_amount: Int
    $interest_rate: Float
    $amortization: Int
    $term: Int
    $maturity_date: String
    $annual_loan_payment: Int
    $cash_flow: Int
    $cash_on_cash: Float
    $dscr: Float
    $prepayment_penalty: String
    $credits_at_closing: Float
    $referral: Float
    $referral_percent: Float
    $noi_percent: Float
    $referred_by_id: String
    $referred_by_type: String
    $referral_type: String
    $hsc_financing: String
    $date_created: String
    $apn: String
    $other_financing: String
    $notes: text
    $rep_agreement_file_1: String
    $rep_agreement_file_2: String
    $rep_agreement_file_3: String
    $rep_agreement_file_4: String
    $rep_agreement_file_5: String
    $in_neg_file_1: String
    $in_neg_file_2: String
    $in_neg_file_3: String
    $in_neg_file_4: String
    $in_neg_file_5: String
    $seller_statement_file: String
    $buyer_statement_file: String
    $website_photo_1: String
    $website_photo_2: String
    $website_photo_3: String
    $website_photo_4: String
    $website_photo_5: String
    $created_by: String
    $flagged_date: String
    $under_contract_in_negotiation_since: String
    $property_info_since: String
    $off_market_since: String
    $last_modified_by: String
    $last_modified_date: String
    $uploaded_from: String
    $is_listing: Int
    $was_proposal: Int
    $estimated_price_type: String
    $sub_category: String
    $units: Int
    $proposal_date: String
    $bank_bonus: Float
    $bank_bonus_percent: Float
    $arcimedes_created: String
    $arcimedes_created_by: String
    $arcimedes_modified: String
    $arcimedes_modified_by: String
  ) {
    createProperty(
      input: {
        deleted: $deleted
        source: $source
        transaction_type: $transaction_type
        status: $status
        visible: $visible
        featured: $featured
        strive_slider: $strive_slider
        name: $name
        address: $address
        city: $city
        state: $state
        zip: $zip
        latitude: $latitude
        longitude: $longitude
        highlights: $highlights
        media_kit: $media_kit
        type: $type
        sqft: $sqft
        list_price: $list_price
        net_operating_income: $net_operating_income
        vacancy: $vacancy
        capitalization_rate: $capitalization_rate
        sold_price: $sold_price
        down_payment: $down_payment
        close_of_escrow: $close_of_escrow
        listed_date: $listed_date
        seller_fee_percentage: $seller_fee_percentage
        total_fee: $total_fee
        lease_type: $lease_type
        lease_commencement_date: $lease_commencement_date
        lease_expiration_date: $lease_expiration_date
        seller_id: $seller_id
        buyer_id: $buyer_id
        year_built: $year_built
        video_url: $video_url
        close_noi: $close_noi
        proforma_noi: $proforma_noi
        proforma_base_rent: $proforma_base_rent
        proforma_cap_rate: $proforma_cap_rate
        close_cap_rate: $close_cap_rate
        close_price_per_sqft: $close_price_per_sqft
        price_per_sqft: $price_per_sqft
        listing_agent_1: $listing_agent_1
        listing_agent_2: $listing_agent_2
        listing_agent_3: $listing_agent_3
        listing_agent_4: $listing_agent_4
        referring_listing_agent: $referring_listing_agent
        listing_agent_4_firm: $listing_agent_4_firm
        referring_listing_agent_firm: $referring_listing_agent_firm
        buyer_agent_1: $buyer_agent_1
        buyer_agent_2: $buyer_agent_2
        buyer_agent_3: $buyer_agent_3
        buyer_agent_4: $buyer_agent_4
        referring_buyer_agent: $referring_buyer_agent
        buyer_agent_4_firm: $buyer_agent_4_firm
        referring_buyer_agent_firm: $referring_buyer_agent_firm
        listing_agent_1_percent: $listing_agent_1_percent
        listing_agent_2_percent: $listing_agent_2_percent
        listing_agent_3_percent: $listing_agent_3_percent
        listing_agent_4_percent: $listing_agent_4_percent
        referring_listing_agent_percent: $referring_listing_agent_percent
        buyer_agent_1_percent: $buyer_agent_1_percent
        buyer_agent_2_percent: $buyer_agent_2_percent
        buyer_agent_3_percent: $buyer_agent_3_percent
        buyer_agent_4_percent: $buyer_agent_4_percent
        referring_buyer_agent_percent: $referring_buyer_agent_percent
        single_tenant_subcategory: $single_tenant_subcategory
        multi_tenant_subcategory: $multi_tenant_subcategory
        tenant_id: $tenant_id
        market: $market
        rent_per_sqft: $rent_per_sqft
        negotiation_price: $negotiation_price
        potential_fee: $potential_fee
        list_fee: $list_fee
        buyside_fee: $buyside_fee
        negotiation_cap_rate: $negotiation_cap_rate
        category: $category
        hide_financials: $hide_financials
        is_proforma_pricing: $is_proforma_pricing
        date_removed: $date_removed
        negotiation_price_per_sqft: $negotiation_price_per_sqft
        base_rent: $base_rent
        expiration_no_of_months: $expiration_no_of_months
        expiration_date: $expiration_date
        effective_date: $effective_date
        referral_fee: $referral_fee
        hsc_team_member_1: $hsc_team_member_1
        hsc_team_member_1_percent: $hsc_team_member_1_percent
        hsc_team_member_1_net_fee: $hsc_team_member_1_net_fee
        hsc_team_member_1_net_percent: $hsc_team_member_1_net_percent
        hsc_team_member_1_gross_fee: $hsc_team_member_1_gross_fee
        hsc_team_member_2: $hsc_team_member_2
        hsc_team_member_2_percent: $hsc_team_member_2_percent
        hsc_team_member_2_net_fee: $hsc_team_member_2_net_fee
        hsc_team_member_2_net_percent: $hsc_team_member_2_net_percent
        hsc_team_member_2_gross_fee: $hsc_team_member_2_gross_fee
        hsc_agreement_file: $hsc_agreement_file
        loan_commitment_file: $loan_commitment_file
        closing_statement_file: $closing_statement_file
        loan_closing_date: $loan_closing_date
        hsc_approved: $hsc_approved
        hsc_approved_timestamp: $hsc_approved_timestamp
        hsc_approved_initials: $hsc_approved_initials
        hsc_status: $hsc_status
        hsc_price: $hsc_price
        hsc_listed_date: $hsc_listed_date
        hsc_expiration_no_of_months: $hsc_expiration_no_of_months
        hsc_expiration_date: $hsc_expiration_date
        hsc_fee_percentage: $hsc_fee_percentage
        hsc_total_fee: $hsc_total_fee
        hsc_list_fee: $hsc_list_fee
        lender_id: $lender_id
        loan_type: $loan_type
        ltv: $ltv
        loan_amount: $loan_amount
        interest_rate: $interest_rate
        amortization: $amortization
        term: $term
        maturity_date: $maturity_date
        annual_loan_payment: $annual_loan_payment
        cash_flow: $cash_flow
        cash_on_cash: $cash_on_cash
        dscr: $dscr
        prepayment_penalty: $prepayment_penalty
        credits_at_closing: $credits_at_closing
        referral: $referral
        referral_percent: $referral_percent
        noi_percent: $noi_percent
        referred_by_id: $referred_by_id
        referred_by_type: $referred_by_type
        referral_type: $referral_type
        hsc_financing: $hsc_financing
        date_created: $date_created
        apn: $apn
        other_financing: $other_financing
        notes: $notes
        rep_agreement_file_1: $rep_agreement_file_1
        rep_agreement_file_2: $rep_agreement_file_2
        rep_agreement_file_3: $rep_agreement_file_3
        rep_agreement_file_4: $rep_agreement_file_4
        rep_agreement_file_5: $rep_agreement_file_5
        in_neg_file_1: $in_neg_file_1
        in_neg_file_2: $in_neg_file_2
        in_neg_file_3: $in_neg_file_3
        in_neg_file_4: $in_neg_file_4
        in_neg_file_5: $in_neg_file_5
        seller_statement_file: $seller_statement_file
        buyer_statement_file: $buyer_statement_file
        website_photo_1: $website_photo_1
        website_photo_2: $website_photo_2
        website_photo_3: $website_photo_3
        website_photo_4: $website_photo_4
        website_photo_5: $website_photo_5
        created_by: $created_by
        flagged_date: $flagged_date
        under_contract_in_negotiation_since: $under_contract_in_negotiation_since
        property_info_since: $property_info_since
        off_market_since: $off_market_since
        last_modified_by: $last_modified_by
        last_modified_date: $last_modified_date
        uploaded_from: $uploaded_from
        is_listing: $is_listing
        was_proposal: $was_proposal
        estimated_price_type: $estimated_price_type
        sub_category: $sub_category
        units: $units
        proposal_date: $proposal_date
        bank_bonus: $bank_bonus
        bank_bonus_percent: $bank_bonus_percent
        arcimedes_created: $arcimedes_created
        arcimedes_created_by: $arcimedes_created_by
        arcimedes_modified: $arcimedes_modified
        arcimedes_modified_by: $arcimedes_modified_by
      }
    ) {
      properties {
        deleted
        source
        transaction_type
        status
        visible
        featured
        strive_slider
        name
        address
        city
        state
        zip
        latitude
        longitude
        highlights
        media_kit
        type
        sqft
        list_price
        net_operating_income
        vacancy
        capitalization_rate
        sold_price
        down_payment
        close_of_escrow
        listed_date
        seller_fee_percentage
        total_fee
        lease_type
        lease_commencement_date
        lease_expiration_date
        seller_id
        buyer_id
        year_built
        video_url
        close_noi
        proforma_noi
        proforma_base_rent
        proforma_cap_rate
        close_cap_rate
        close_price_per_sqft
        price_per_sqft
        listing_agent_1
        listing_agent_2
        listing_agent_3
        listing_agent_4
        referring_listing_agent
        listing_agent_4_firm
        referring_listing_agent_firm
        buyer_agent_1
        buyer_agent_2
        buyer_agent_3
        buyer_agent_4
        referring_buyer_agent
        buyer_agent_4_firm
        referring_buyer_agent_firm
        listing_agent_1_percent
        listing_agent_2_percent
        listing_agent_3_percent
        listing_agent_4_percent
        referring_listing_agent_percent
        buyer_agent_1_percent
        buyer_agent_2_percent
        buyer_agent_3_percent
        buyer_agent_4_percent
        referring_buyer_agent_percent
        single_tenant_subcategory
        multi_tenant_subcategory
        tenant_id
        market
        rent_per_sqft
        negotiation_price
        potential_fee
        list_fee
        buyside_fee
        negotiation_cap_rate
        category
        hide_financials
        is_proforma_pricing
        date_removed
        negotiation_price_per_sqft
        base_rent
        expiration_no_of_months
        expiration_date
        effective_date
        referral_fee
        hsc_team_member_1
        hsc_team_member_1_percent
        hsc_team_member_1_net_fee
        hsc_team_member_1_net_percent
        hsc_team_member_1_gross_fee
        hsc_team_member_2
        hsc_team_member_2_percent
        hsc_team_member_2_net_fee
        hsc_team_member_2_net_percent
        hsc_team_member_2_gross_fee
        hsc_agreement_file
        loan_commitment_file
        closing_statement_file
        loan_closing_date
        hsc_approved
        hsc_approved_timestamp
        hsc_approved_initials
        hsc_status
        hsc_price
        hsc_listed_date
        hsc_expiration_no_of_months
        hsc_expiration_date
        hsc_fee_percentage
        hsc_total_fee
        hsc_list_fee
        lender_id
        loan_type
        ltv
        loan_amount
        interest_rate
        amortization
        term
        maturity_date
        annual_loan_payment
        cash_flow
        cash_on_cash
        dscr
        prepayment_penalty
        credits_at_closing
        referral
        referral_percent
        noi_percent
        referred_by_id
        referred_by_type
        referral_type
        hsc_financing
        date_created
        apn
        other_financing
        notes
        rep_agreement_file_1
        rep_agreement_file_2
        rep_agreement_file_3
        rep_agreement_file_4
        rep_agreement_file_5
        in_neg_file_1
        in_neg_file_2
        in_neg_file_3
        in_neg_file_4
        in_neg_file_5
        seller_statement_file
        buyer_statement_file
        website_photo_1
        website_photo_2
        website_photo_3
        website_photo_4
        website_photo_5
        created_by
        flagged_date
        under_contract_in_negotiation_since
        property_info_since
        off_market_since
        last_modified_by
        last_modified_date
        uploaded_from
        is_listing
        was_proposal
        estimated_price_type
        sub_category
        units
        proposal_date
        bank_bonus
        bank_bonus_percent
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
        hotlist_properties
        hotlist_id
        hotlist_name
        hotlist_email_id
      }
    }
  }
`;

export const PROPERTIES_MUTATION = gql`
  mutation createOrUpdateProperty($input: [PropertyInput]!) {
    createOrUpdateProperty(input: $input) {
      success
      message
      data {
       arcimedes_row_id
      deleted
      source
      transaction_type
      status
      visible
      featured
      strive_slider
      name
      address
      city
      state
      zip
      latitude
      longitude
      highlights
      media_kit
      type
      sqft
      list_price
      net_operating_income
      vacancy
      capitalization_rate
      sold_price
      down_payment
      close_of_escrow
      listed_date
      seller_fee_percentage
      total_fee
      lease_type
      lease_commencement_date
      lease_expiration_date
      seller_id
      buyer_id
      year_built
      video_url
      close_noi
      proforma_noi
      proforma_base_rent
      proforma_cap_rate
      close_cap_rate
      close_price_per_sqft
      price_per_sqft
      listing_agent_1
      listing_agent_2
      listing_agent_3
      listing_agent_4
      referring_listing_agent
      listing_agent_4_firm
      referring_listing_agent_firm
      buyer_agent_1
      buyer_agent_2
      buyer_agent_3
      buyer_agent_4
      referring_buyer_agent
      buyer_agent_4_firm
      referring_buyer_agent_firm
      listing_agent_1_percent
      listing_agent_2_percent
      listing_agent_3_percent
      listing_agent_4_percent
      referring_listing_agent_percent
      buyer_agent_1_percent
      buyer_agent_2_percent
      buyer_agent_3_percent
      buyer_agent_4_percent
      referring_buyer_agent_percent
      single_tenant_subcategory
      multi_tenant_subcategory
      tenant_id
      market
      rent_per_sqft
      negotiation_price
      potential_fee
      list_fee
      buyside_fee
      negotiation_cap_rate
      category
      hide_financials
      is_proforma_pricing
      date_removed
      negotiation_price_per_sqft
      base_rent
      expiration_no_of_months
      expiration_date
      effective_date
      referral_fee
      hsc_team_member_1
      hsc_team_member_1_percent
      hsc_team_member_1_net_fee
      hsc_team_member_1_net_percent
      hsc_team_member_1_gross_fee
      hsc_team_member_2
      hsc_team_member_2_percent
      hsc_team_member_2_net_fee
      hsc_team_member_2_net_percent
      hsc_team_member_2_gross_fee
      hsc_agreement_file
      loan_commitment_file
      closing_statement_file
      loan_closing_date
      hsc_approved
      hsc_approved_timestamp
      hsc_approved_initials
      hsc_status
      hsc_price
      hsc_listed_date
      hsc_expiration_no_of_months
      hsc_expiration_date
      hsc_fee_percentage
      hsc_total_fee
      hsc_list_fee
      lender_id
      loan_type
      ltv
      loan_amount
      interest_rate
      amortization
      term
      maturity_date
      annual_loan_payment
      cash_flow
      cash_on_cash
      dscr
      prepayment_penalty
      credits_at_closing
      referral
      referral_percent
      noi_percent
      referred_by_id
      referred_by_type
      referral_type
      hsc_financing
      date_created
      apn
      other_financing
      notes
      rep_agreement_file_1
      rep_agreement_file_2
      rep_agreement_file_3
      rep_agreement_file_4
      rep_agreement_file_5
      in_neg_file_1
      in_neg_file_2
      in_neg_file_3
      in_neg_file_4
      in_neg_file_5
      seller_statement_file
      buyer_statement_file
      website_photo_1
      website_photo_2
      website_photo_3
      website_photo_4
      website_photo_5
      created_by
      flagged_date
      under_contract_in_negotiation_since
      property_info_since
      off_market_since
      last_modified_by
      last_modified_date
      uploaded_from
      is_listing
      was_proposal
      estimated_price_type
      sub_category
      units
      lot_size
      parking_spaces
      proposal_date
      bank_bonus
      bank_bonus_percent
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
      agent_1_first_name
      agent_1_last_name
      agent_2_first_name
      agent_2_last_name
      agent_3_first_name
      agent_3_last_name
      agent_4_first_name
      agent_4_last_name
      sellers_first_name
      sellers_last_name
      lender_name
      hotlist_properties
      hotlist_id
      hotlist_name
      hotlist_email_id
      flip_book_link
    }
    error
    message
    success
    }
  }
`;

export const PROPOSAL_MUTATION = gql`
  mutation createOrUpdateProposal($input: [ProposalInput]!) {
    createOrUpdateProposal(input: $input) {
      success
      message
      data {
        arcimedes_row_id
        property_id
        strengths
        challenges
        buyer_pool
        qualifications
        recommendations
      }
    }
  }
`;

// export const SELLERS_MUTATION = gql`
//   mutation createOrUpdateSeller($input: SellerInput!) {
//     createOrUpdateSeller(input: $input) {
//       success
//       message
//       seller {
//         arcimedes_row_id
//       }
//     }
//   }
// `;

export const SELLERS_MUTATION = gql`
  mutation CreateOrUpdateSellers($input: [SellerInput]!) {
  createOrUpdateSellers(input: $input) {
    success
    message
    data {
      ARCIMEDES_ROW_ID
      STATUS
      AGENT
      FIRST_NAME
      LAST_NAME
      COMPANY_NAME
      COMPANY_ADDRESS
      COMPANY_CITY
      COMPANY_STATE
      COMPANY_ZIP
      PHONE
      EMAIL
      NOTES
      PROFILE
      CELL_PHONE
      LAST_MODIFIED
      DELETED
      ARCIMEDES_CREATED
      ARCIMEDES_CREATED_BY
      ARCIMEDES_MODIFIED
      ARCIMEDES_MODIFIED_BY
      first_name
      last_name
      phone
      email
      profile
      notes
      company_name
      company_address
      company_city
      company_state
      company_zip
    }
    error
  }
}
`;

export const HSC_LOAN_QUOTES_MUTATION = gql`
mutation HscLoanQuotesInput($input: [HscLoanQuotesInput]) {
  createOrUpdateHscLoanQuote(input: $input) {
    success
    message
    data {
      arcimedes_row_id
      property_id
      loan_structure
      purchase_price
      down_payment_percent
      down_payment
      loan_amount
      interest_rate
      loan_term
      maturity
      amortization
      prepayment_penalty
      loan_payment_monthly
      loan_payment_annually
      cap_rate
      noi
      cash_flow_monthly
      cash_flow_annually
      cash_on_cash
      notes
      noi_multiplied
      dscr
      debt_yield
      bank
      bank_contact
      deleted
      noi_percentage
      recourse
      total_origination_fee
      is_printable
      print_page_number
      autopopulate
      loan_quotes_order
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
`;

// export const PROPERTY_PAYMENT_TEAM_MUTATION = gql`
//   mutation createOrUpdatePropertyPaymentTeam($data: [InputType!]!) {
//     createOrUpdatePropertyPaymentTeam(input: $input) {
//       success
//       message
//       propertyPaymentTeam {
//         arcimedes_row_id
//       }
//     }
//   }
// `;
export const PROPERTY_PAYMENT_TEAM_MUTATION = gql`
mutation CreateOrUpdatePropertyPaymentTeam($input: [PropertyPaymentTeamInput]!) {
  createOrUpdatePropertyPaymentTeam(input: $input) {
    success
    message
    data {
      arcimedes_row_id
      property_id
      deleted
      strive_team_member_id
      strive_team_member_percent
      strive_team_member_net_fee
      strive_team_member_net_percent
      strive_team_member_gross_fee
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
  `

// mutation property_history_mutation($data: [InputType!]!) {
//   property_history_mutation(data: $data) {
//     success
//     message
//     data {
//       arcimedes_row_id
//     }
//   }
// }
export const PROPERTY_HISTORY_MUTATION = gql`
 mutation CreateOrUpdatePropertyHistory($input: PropertyHistoryInput) {
  createOrUpdatePropertyHistory(input: $input) {
    success
    message
    propertyHistory {
      arcimedes_row_id
      deleted
      status
    }
    error
  }
}
`;
// export const UNDERWRITING_TENANTS = gql`
//   mutation createOrUpdateUnderwritingTenent($input:[UnderwritingTenentsInput]!){
//     createOrUpdateUnderwritingTenent(input: $input){
//       success
//       message
//       underwritingTenent {
//         arcimedes_row_id
//       }
//     }
//   }
// `;

export const UNDERWRITING_TENANTS = gql`
 mutation CreateOrUpdateUnderwritingTenent($input: [UnderwritingTenentsInput]) {
  createOrUpdateUnderwritingTenent(input: $input) {
    success
    message
    underwritingTenent {
      arcimedes_row_id
      deleted
      property_id
      tenant_row_id
      tenant_id
      tenant_name
      rr_suite_code
      rr_sqft
      rr_start_date
      rr_end_date
      rr_monthly_rent
      rr_escalation_date
      rr_escalation_monthly_rent
      rr_options
      rr_option_1_rent
      rr_option_2_rent
      rr_option_3_rent
      rr_option_4_rent
      rr_option_5_rent
      rr_notes
      proforma_rr_tenant_name
      proforma_rr_sqft
      proforma_rr_start_date
      proforma_rr_end_date
      proforma_rr_psf
      proforma_ti_sf
      proforma_lc
      reimb_code
      reimb_annual_other
      reimb_notes
      reimb_annual_other_1
      reimb_monthly_ret
      reimb_monthly_ins
      reimb_monthly_cam
      reimb_monthly_other
      proforma_reimb_code
    }
    error
  }
}
`;
 export const UPDATE_UNDERWRITING_TENENT_TYPES = gql`
 mutation CreateOrUpdateUnderwritingTenentType($input: [UnderwritingTenentTypesInput]) {
  createOrUpdateUnderwritingTenentType(input: $input) {
    success
    message
    data {
      arcimedes_row_id
      deleted
      property_id
      reimb_types_index
      reimb_types_description
      reimb_types_cam_increase
      reimb_types_has_cam
      reimb_types_cam_value
      reimb_types_mgmt_fee_value
      reimb_types_has_management_fee
      reimb_types_has_insurance
      reimb_types_insurance_value
      reimb_types_has_taxes
      reimb_types_taxes_value
      pro_forma_reimb_types_description
      pro_forma_reimb_types_cam_increase
      pro_forma_reimb_types_has_cam
      pro_forma_reimb_types_cam_value
      pro_forma_reimb_types_mgmt_fee_value
      pro_forma_reimb_types_has_management_fee
      pro_forma_reimb_types_has_insurance
      pro_forma_reimb_types_insurance_value
      pro_forma_reimb_types_has_taxes
      pro_forma_reimb_types_taxes_value
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
 `
 export const UPDATE_UNDERWRITING_MULTI_TENANT = gql`
 mutation CreateOrUpdateUnderwritingMultiTenent($input: UnderwritingMultiTenentsInput) {
  createOrUpdateUnderwritingMultiTenent(input: $input) {
    success
    message
    underwritingMultiTenent {
      arcimedes_row_id
      property_id
      lot_size
      current_tax_appraised_value
      current_tax_liability
      google_maps_link
      cad_link_1
      cad_link_2
      cad_link_3
      cad_link_4
      as_is_checkbox
      proforma_checkbox
      assumable_loan_checkbox
      analysis_date
      additional_price_type
      additional_price
      principal_balance
      proforma_principal_balance
      loan_amount
      proforma_loan_amount
      down_payment
      proforma_down_payment
      down_payment_percent
      proforma_down_payment_percent
      vacancy_factor
      proforma_yield
      interest_rate
      proforma_interest_rate
      amortization
      proforma_amortization
      pricing_bps_increase
      pricing_bps_increase_pro
      current_real_estate_taxes
      current_insurance
      current_non_reimb_expenses
      current_rr_end_months
      current_rr_term
      current_rr_notes
      expenses_management_fee_of_gpi
      expenses_current_year
      expenses_notes
      proforma_vacancy_factor
      proforma_real_estate_taxes
      proforma_insurance
      proforma_non_reimb_expenses
      proforma_mgmt_fee_of_gpi
      map_image
      reimb_types_manually_modified
      proforma_additional_price
      proforma_analysis_date
      annual_other_income
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
 `
//  export const UPDATE_UNDERWRITING_SINGLE_TENANT = gql`
//  mutation CreateOrUpdateUnderwritingSingleTenent($input: UnderwritingSingleTenentsInput) {
//   createOrUpdateUnderwritingSingleTenent(input: $input) {
//     success
//     message
//     data {
//       arcimedes_row_id
//       property_id
//       cad_link
//       appraised_value
//       analysis_date
//       sale_lease_back
//       price_psf
//       lot_size
//       original_lease_term
//       increases
//       guarantor
//       options
//       options_to_purchase
//       pricing_range_bps_change
//       pricing_range_price_psf_change
//       loan_info_down_payment
//       loan_info_interest_rate
//       loan_info_amortization
//       addition_type
//       addition_value
//       addition_type2
//       addition_value2
//       addition_type3
//       addition_value3
//       addition_type4
//       addition_value4
//       lease_notes
//       clear_height
//       doors
//       office_to_warehouse
//       arcimedes_created
//       arcimedes_created_by
//       arcimedes_modified
//       arcimedes_modified_by
//     }
//     error
//   }
// }
//  `

 export const UPDATE_UNDERWRITING_SINGLE_TENANT = gql`
 mutation CreateOrUpdateUnderwritingSingleTenent($input: [UnderwritingSingleTenentsInput]) {
  createOrUpdateUnderwritingSingleTenent(input: $input) {
    success
    message
    data {
      arcimedes_row_id
      property_id
      cad_link
      appraised_value
      analysis_date
      sale_lease_back
      price_psf
      lot_size
      original_lease_term
      increases
      guarantor
      options
      options_to_purchase
      pricing_range_bps_change
      pricing_range_price_psf_change
      loan_info_down_payment
      loan_info_interest_rate
      loan_info_amortization
      addition_type
      addition_value
      addition_type2
      addition_value2
      addition_type3
      addition_value3
      addition_type4
      addition_value4
      lease_notes
      clear_height
      doors
      office_to_warehouse
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
 `
 export const UPDATE_UNDERWRITING_RENT_SCHEDULE = gql`
 mutation CreateOrUpdateUnderwritingRentSchedule($input: [UnderwritinRentSchedulesInput]) {
  createOrUpdateUnderwritingRentSchedule(input: $input) {
    success
    message
    data {
      arcimedes_row_id
      property_id
      deleted
      years
      lease_commencement
      monthly_rent
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
 `
 export const UPDATE_UNDERWRITING_EXPENSES_CAMS = gql`
 mutation CreateOrUpdateUnderwritingExpensesCams($input: [UnderwritingExpencesCamsInput]) {
  createOrUpdateUnderwritingExpensesCams(input: $input) {
    success
    message
    data {
      arcimedes_row_id
      property_id
      cam_index
      deleted
      cam_name
      cam_value
      proforma_cam_value
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
 `
//#region below Two are Common queries, so retun responce variable name should be same
export const STRIVE_ESCROW_TRACKING_MUTATION = gql`
  mutation striveEscrowTracking($data: [InputType!]!) {
    striveEscrowTracking(data: $data) {
      success
      message
      data {
        arcimedes_row_id
      }
    }
  }
`;

export const HSC_TRACKING_MUTATION = gql`
  mutation hscTracking($data: [InputType!]!) {
    hscTracking(data: $data) {
      success
      message
      data {
        arcimedes_row_id
      }
    }
  }
`;

export const DELETE_PROPERTIES = gql`
  query deleteProperties($inputs: [PropertyDeleteInput!]!) {
    deleteProperties(inputs: $inputs) {
      success
      message
    }
  }
`;

export const  CREATE_TENANTS_IN_MULTITENANT = gql`
mutation CreateOrUpdateContact($input: ContactInput) {
  createOrUpdateContact(input: $input) {
    success
    message
    contact {
      contact_id
      contact_type
      arcimedes_row_id
      first_name
      last_name
      deleted
      name
    }
    error
  }
}
`;

export const PROPERTY_NOTES_MUTATION = gql`
 mutation CreateOrUpdatePropertyNotes($input: [PropertyNotesInput]) {
  createOrUpdatePropertyNotes(input: $input) {
    success
    message
    PropertyNotes {
      ARCIMEDES_ROW_ID
      PROPERTY_ID
      NOTES
      ADDRESS
      LATITUDE
      LONGITUDE
      DELETED
      CREATED
      MODIFIED
      CREATED_BY
      MODIFIED_BY
    }
    error
  }
}
`;

//#endregion
